"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACL_LINK = void 0;
exports.createAclLogic = createAclLogic;
var rdflib_1 = require("rdflib");
var ns_1 = require("../util/ns");
exports.ACL_LINK = (0, rdflib_1.sym)("http://www.iana.org/assignments/link-relations/acl");
function createAclLogic(store) {
    var ns = ns_1.ns;
    function findAclDocUrl(url) {
        return __awaiter(this, void 0, void 0, function () {
            var docNode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, store.fetcher.load(url)];
                    case 1:
                        _a.sent();
                        docNode = store.any(url, exports.ACL_LINK);
                        if (!docNode) {
                            throw new Error("No ACL link discovered for ".concat(url));
                        }
                        return [2 /*return*/, docNode.value];
                }
            });
        });
    }
    /**
     * Simple Access Control
     *
     * This function sets up a simple default ACL for a resource, with
     * RWC for the owner, and a specified access (default none) for the public.
     * In all cases owner has read write control.
     * Parameter lists modes allowed to public
     *
     * @param options
     * @param options.public eg ['Read', 'Write']
     *
     * @returns Resolves with aclDoc uri on successful write
     */
    function setACLUserPublic(docURI, me, options) {
        var aclDoc = store.any(store.sym(docURI), exports.ACL_LINK);
        return Promise.resolve()
            .then(function () {
            if (aclDoc) {
                return aclDoc;
            }
            return fetchACLRel(docURI).catch(function (err) {
                throw new Error("Error fetching rel=ACL header for ".concat(docURI, ": ").concat(err));
            });
        })
            .then(function (aclDoc) {
            var aclText = genACLText(docURI, me, aclDoc.uri, options);
            if (!store.fetcher) {
                throw new Error('Cannot PUT this, store has no fetcher');
            }
            return store.fetcher
                .webOperation('PUT', aclDoc.uri, {
                data: aclText,
                contentType: 'text/turtle'
            })
                .then(function (result) {
                if (!result.ok) {
                    throw new Error('Error writing ACL text: ' + result.error);
                }
                return aclDoc;
            });
        });
    }
    /**
     * @param docURI
     * @returns
     */
    function fetchACLRel(docURI) {
        var fetcher = store.fetcher;
        if (!fetcher) {
            throw new Error('Cannot fetch ACL rel, store has no fetcher');
        }
        return fetcher.load(docURI).then(function (result) {
            if (!result.ok) {
                throw new Error('fetchACLRel: While loading:' + result.error);
            }
            var aclDoc = store.any(store.sym(docURI), exports.ACL_LINK);
            if (!aclDoc) {
                throw new Error('fetchACLRel: No Link rel=ACL header for ' + docURI);
            }
            return aclDoc;
        });
    }
    /**
     * @param docURI
     * @param me
     * @param aclURI
     * @param options
     *
     * @returns Serialized ACL
     */
    function genACLText(docURI, me, aclURI, options) {
        if (options === void 0) { options = {}; }
        var optPublic = options.public || [];
        var g = (0, rdflib_1.graph)();
        var auth = (0, rdflib_1.Namespace)('http://www.w3.org/ns/auth/acl#');
        var a = g.sym("".concat(aclURI, "#a1"));
        var acl = g.sym(aclURI);
        var doc = g.sym(docURI);
        g.add(a, ns.rdf('type'), auth('Authorization'), acl);
        g.add(a, auth('accessTo'), doc, acl);
        if (options.defaultForNew) {
            g.add(a, auth('default'), doc, acl);
        }
        g.add(a, auth('agent'), me, acl);
        g.add(a, auth('mode'), auth('Read'), acl);
        g.add(a, auth('mode'), auth('Write'), acl);
        g.add(a, auth('mode'), auth('Control'), acl);
        if (optPublic.length) {
            a = g.sym("".concat(aclURI, "#a2"));
            g.add(a, ns.rdf('type'), auth('Authorization'), acl);
            g.add(a, auth('accessTo'), doc, acl);
            g.add(a, auth('agentClass'), ns.foaf('Agent'), acl);
            for (var p = 0; p < optPublic.length; p++) {
                g.add(a, auth('mode'), auth(optPublic[p]), acl); // Like 'Read' etc
            }
        }
        return (0, rdflib_1.serialize)(acl, g, aclURI);
    }
    return {
        findAclDocUrl: findAclDocUrl,
        setACLUserPublic: setACLUserPublic,
        genACLText: genACLText
    };
}
//# sourceMappingURL=aclLogic.js.map